var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDateIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 672.2",
    style: {
      enableBackground: "new 0 0 600 672.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#09244B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Map",
    transform: "translate(-672.000000, -48.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clock_fill",
    transform: "translate(672.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6",
    className: "st0",
    d: "M300,0c165.7,0,300,134.3,300,300c0,102.5-55.9,186.3-114.7,246.5c-32.3,33-66.6,60.1-95.9,80.6 l-14.2,9.7c-2.3,1.5-4.5,3-6.7,4.4l-12.5,8l0,0l-11.2,6.8l0,0l-13.9,8.1l0,0c-19.3,10.9-42.5,10.9-61.8,0l-13.9-8.1l0,0 l-17.3-10.7c-2.1-1.3-4.2-2.7-6.4-4.1l-13.7-9.1c-30.7-21-68.1-49.8-103.1-85.5C55.9,486.3,0,402.5,0,300C0,134.3,134.3,0,300,0z  M402.6,199.4L261.2,340.9L202.2,282c-13-13-34.1-13-47.1,0c-13,13-13,34.1,0,47.1l80.1,80.1c14.3,14.3,37.5,14.3,51.9,0 l162.7-162.7c13-13,13-34.1,0-47.1C436.8,186.4,415.7,186.4,402.6,199.4z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateIcon);
export default __webpack_public_path__ + "static/media/date_icon.22d02a6d2f3e6f6b3f677043b0d94db9.svg";
export { ForwardRef as ReactComponent };